import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import s from './Financeiro.module.css';
import InputDataFiltro from '../components/common/InputDataFiltro';

const fmtDT = d => d ? new Date(d).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'medium' }) : '—';

const OPERACOES = {
  cancelar_venda:            { l: 'Cancelamento de venda',            cor: '#b91c1c' },
  cancelar_pedido:           { l: 'Cancelamento de pedido',           cor: '#b91c1c' },
  cancelar_devolucao:        { l: 'Cancelamento de devolução',        cor: '#b91c1c' },
  cancelar_baixa_cartao:     { l: 'Cancelamento de baixa de cartão',  cor: '#b91c1c' },
  estornar_pendencia_cartao: { l: 'Estorno de pendência de cartão',   cor: '#b45309' },
  estornar_recebimento:      { l: 'Estorno de recebimento',           cor: '#b45309' },
  cancelar_conta_receber:    { l: 'Cancelamento de conta a receber',  cor: '#b91c1c' },
  cancelar_conta_pagar:      { l: 'Cancelamento de conta a pagar',    cor: '#b91c1c' },
  alterar_manutencao_estoque: { l: 'Alteração de contagem de estoque', cor: '#b45309' },
  alterar_financeiro:         { l: 'Alteração de lançamento financeiro', cor: '#b45309' },
  excluir_financeiro:         { l: 'Exclusão de lançamento financeiro', cor: '#b91c1c' },
  liberar_desconto_maximo:    { l: 'Liberação de desconto acima do máximo', cor: '#b45309' },
  liberar_estoque_insuficiente: { l: 'Liberação de venda com estoque insuficiente', cor: '#b45309' },
  liberar_limite_credito:     { l: 'Liberação de venda acima do limite de crédito', cor: '#b45309' },
  liberar_cliente_inadimplente: { l: 'Liberação de venda a prazo p/ cliente inadimplente', cor: '#b45309' },
};

const ENTIDADE_LABEL = {
  venda: 'Venda', pedido: 'Pedido', devolucao: 'Devolução',
  baixa_cartao: 'Baixa', conta_receber: 'C. Receber', conta_pagar: 'C. Pagar',
  manutencoes_estoque: 'Manutenção de Estoque',
  movimentacoes_financeiras: 'Movimentação Financeira',
};

export default function Auditoria() {
  const [de, setDe]             = useState('');
  const [ate, setAte]           = useState('');
  const [operacao, setOperacao] = useState('');
  const [lista, setLista]       = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro]         = useState('');

  const carregar = useCallback(async (f = {}) => {
    setCarregando(true); setErro('');
    try {
      const { data } = await api.get('/auditoria', { params: {
        de:       'de'       in f ? f.de       : (de       || undefined),
        ate:      'ate'      in f ? f.ate      : (ate      || undefined),
        operacao: 'operacao' in f ? f.operacao : (operacao || undefined),
      }});
      setLista(data);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao carregar auditoria.');
    } finally { setCarregando(false); }
  }, [de, ate, operacao]);

  useEffect(() => { carregar(); }, []); // eslint-disable-line

  const mudar = (k, v) => {
    if (k === 'de') setDe(v);
    if (k === 'ate') setAte(v);
    if (k === 'operacao') setOperacao(v);
    carregar({ [k]: v || undefined });
  };

  return (
    <div className={s.erpWrap}>
      <div className={s.titleBar}><span>🔒</span> Auditoria — Estornos e Cancelamentos</div>

      <div className={s.toolbar} style={{ alignItems: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 3, fontSize: 12 }}>
          De
          <InputDataFiltro className={s.inputErp} style={{ width: 130 }} value={de}
            onChange={e => mudar('de', e.target.value)} />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 3, fontSize: 12 }}>
          Até
          <InputDataFiltro className={s.inputErp} style={{ width: 130 }} value={ate}
            onChange={e => mudar('ate', e.target.value)} />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 3, fontSize: 12, minWidth: 240 }}>
          Operação
          <select className={s.selectErp} value={operacao} onChange={e => mudar('operacao', e.target.value)}>
            <option value="">— Todas —</option>
            {Object.entries(OPERACOES).map(([v, o]) => <option key={v} value={v}>{o.l}</option>)}
          </select>
        </label>
        <button className={s.btnErp} onClick={() => carregar()}>↻ Atualizar</button>
        <span style={{ marginLeft: 'auto', fontSize: 11, color: '#666', alignSelf: 'center' }}>
          {lista.length} registro(s)
        </span>
      </div>

      {erro && <div className={s.erroMsg}>{erro}</div>}

      <div className={s.conteudo}>
        {carregando
          ? <div style={{ color: '#888', fontSize: 12 }}>Carregando...</div>
          : lista.length === 0
            ? <div style={{ color: '#888', fontSize: 12 }}>Nenhuma operação registrada no período.</div>
            : (
              <table className={s.tabela}>
                <thead>
                  <tr>
                    <th style={{ width: 150 }}>Data/Hora</th>
                    <th style={{ width: 240 }}>Operação</th>
                    <th style={{ width: 110 }}>Registro</th>
                    <th>Detalhes</th>
                    <th style={{ width: 140 }}>Executado por</th>
                    <th style={{ width: 140 }}>Autorizado por</th>
                  </tr>
                </thead>
                <tbody>
                  {lista.map(a => {
                    const op = OPERACOES[a.operacao] || { l: a.operacao, cor: '#333' };
                    return (
                      <tr key={a.id}>
                        <td style={{ fontSize: 11 }}>{fmtDT(a.criado_em)}</td>
                        <td style={{ color: op.cor, fontWeight: 600 }}>{op.l}</td>
                        <td>{ENTIDADE_LABEL[a.entidade] || a.entidade} #{a.entidade_id ?? '—'}</td>
                        <td style={{ fontSize: 11, color: '#555' }}>{a.detalhes || '—'}</td>
                        <td>{a.usuario_nome || '—'}</td>
                        <td style={{ fontWeight: 600 }}>🔑 {a.admin_nome || '—'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
      </div>
    </div>
  );
}
